"use client";

import { useState } from "react";

export default function CatOracleSystem() {
    const [loadingCat, setLoadingCat] = useState(false);
    const [loadingQuote, setLoadingQuote] = useState(false);
    const [cat, setCat] = useState<string | null>(null);
    const [fortune, setFortune] = useState("");

    const generate = async () => {

        setLoadingCat(true);
        setLoadingQuote(true);


        const fetchCat = fetch("https://api.thecatapi.com/v1/images/search").then(res => res.json());
        const fetchAdvice = fetch("https://api.adviceslip.com/advice", { cache: "no-store" }).then(res => res.json());


        fetchAdvice.then(data => {
            setFortune(`"${data.slip.advice}"\n\n— Street Cat`);
            setLoadingQuote(false);
        }).catch(() => {
            setFortune("MANTRA ERROR: GAGAL MEMANGGIL KUCING.");
            setLoadingQuote(false);
        });

        fetchCat.then(data => {
            setCat(data[0].url);
            setLoadingCat(false);
        }).catch(() => {
            setLoadingCat(false);
        });
    };

    return (
        <div className="h-[100dvh] w-full bg-[#020617] text-slate-200 font-sans p-4 lg:p-8 flex flex-col items-center">
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#06b6d4_1px,transparent_1px)] [background-size:40px_40px]" />
            <div className="relative flex h-full max-h-[90vh] w-full max-w-lg lg:max-w-7xl flex-col lg:grid lg:grid-cols-2 gap-4 justify-center items-stretch py-2 z-10 overflow-hidden">
                
                <div className="border border-cyan-500/30 bg-[#0f172a]/80 backdrop-blur-xl shadow-[0_0_60px_rgba(6,182,212,0.12)] overflow-hidden flex flex-col h-1/2 lg:h-auto">
                    <div className="border-b border-cyan-500/30 px-4 py-2 flex justify-between items-center shrink-0">
                        <div className="text-xs tracking-[0.4em] text-cyan-400 font-bold">CAT DISTRIBUTION SYSTEM</div>
                        <div className="text-[10px] text-slate-500 animate-pulse">ONLINE</div>
                    </div>
                    <div className="relative flex-1 min-h-0 bg-black flex items-center justify-center overflow-hidden">
                        {!cat ? (
                            <div className="text-center p-4 text-[10px] text-cyan-400 tracking-[0.3em]">
                                {loadingCat ? "Meong ..." : "FRESH FISH PROTOCOL READY"}
                            </div>
                        ) : (
                            <img src={cat} alt="Oracle Cat" className="h-full w-full object-cover" />
                        )}
                        {loadingCat && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm">
                                <div className="text-cyan-400 text-xs animate-pulse">PSS PSS PSS ...</div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="border border-cyan-500/30 bg-[#0f172a]/80 backdrop-blur-xl shadow-[0_0_60px_rgba(6,182,212,0.12)] p-4 lg:p-6 flex flex-col justify-between shrink-0 lg:shrink-1 lg:flex-1">
                    <div>
                        <div className="text-[10px] tracking-[0.4em] text-cyan-400 mb-4">TODAY MESSAGE</div>
                        <div className="min-h-[140px] flex items-center">
                            {loadingQuote ? (
                                <div className="text-slate-500 italic animate-pulse">Meong Meow Gatito ...</div>
                            ) : (
                                <p className="text-slate-200 text-base lg:text-lg leading-loose font-light italic whitespace-pre-line">
                                    {fortune || "stardenburdenhardenbart . . ."}
                                </p>
                            )}
                        </div>
                    </div>
                    <button
                        onClick={generate}
                        disabled={loadingCat || loadingQuote}
                        className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-bold tracking-[0.2em] py-4 transition-all disabled:opacity-50"
                    >
                        {loadingCat || loadingQuote ? "Meong ..." : "FIND CAT"}
                    </button>
                </div>
            </div>
        </div>
    );
}